// Vollea — Leagues list (private — code-only access). Join card + my-leagues list.
import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { IoTrophy, IoChevronForward, IoArchive, IoLockClosedOutline } from "react-icons/io5";
import { Card, Btn, Header, Input, Empty } from "../components/ui-vollea";
import { api } from "../lib/api";
import { C, SP, R } from "../lib/theme";

export default function Leagues() {
  const navigate = useNavigate();
  const [leagues, setLeagues] = useState([]);
  const [code, setCode] = useState("");
  const [msg, setMsg] = useState("");
  const [msgOk, setMsgOk] = useState(false);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await api.get(`/leagues?mine=true`);
      setLeagues(data || []);
    } catch { setLeagues([]); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const join = async (e) => {
    e?.preventDefault?.();
    if (!code.trim()) return;
    setMsg(""); setMsgOk(false);
    try {
      const lg = await api.post("/leagues/join", { code: code.trim() });
      setMsgOk(true);
      setMsg(`Joined ${lg.name}!`);
      setCode("");
      load();
    } catch (e) { setMsgOk(false); setMsg(e.message); }
  };

  return (
    <div style={{ background: C.bg, minHeight: "100vh", paddingBottom: 90 }}>
      <Header
        title="Leagues"
        subtitle="Private — entry by league code only"
        testid="leagues-page-title"
      />

      <div style={{ padding: `0 ${SP.lg}px ${SP.lg}px` }}>
        <Card style={{ marginBottom: SP.lg }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 6, color: C.textMuted, fontSize: 11, fontWeight: 700, letterSpacing: 1, textTransform: "uppercase" }}>
            <IoLockClosedOutline size={12} /> Join with league code
          </div>
          <form onSubmit={join} style={{ display: "flex", gap: SP.sm, marginTop: SP.sm }}>
            <Input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="e.g. VOLLEA" testid="leagues-join-input" autoCapitalize="characters" />
            <Btn label="JOIN" onClick={join} testid="leagues-join-button" style={{ width: 90, height: 52 }} type="submit" />
          </form>
          {msg ? (
            <div
              data-testid="leagues-join-msg"
              style={{
                marginTop: SP.md,
                background: msgOk ? C.limeTint : "rgba(239,68,68,0.1)",
                border: `1px solid ${msgOk ? C.lime : C.error}`,
                color: msgOk ? C.lime : C.error,
                padding: SP.md, borderRadius: R.md, fontSize: 13, fontWeight: 600,
              }}
            >{msg}</div>
          ) : null}
          <p style={{ color: C.textDim, fontSize: 12, margin: `${SP.sm}px 0 0` }}>
            Ask the league organiser for the code. Leagues are private — they don't appear in any public directory.
          </p>
        </Card>

        {loading ? (
          <div style={{ display: "flex", justifyContent: "center", padding: SP.xl, color: C.lime }}>Loading…</div>
        ) : leagues.length === 0 ? (
          <Empty icon={<IoLockClosedOutline size={36} color={C.textDim} />} text="No leagues joined yet. Paste a code above to enter your first league." />
        ) : leagues.map((l) => (
          <Card key={l.league_id} style={{ marginBottom: SP.sm }} onClick={() => navigate(`/leagues/${l.league_id}`)} testid={`league-card-${l.league_id}`}>
            <div style={{ display: "flex", alignItems: "center", gap: SP.md }}>
              <div style={{ width: 40, height: 40, borderRadius: R.md, background: C.limeTint, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <IoTrophy size={20} color={C.lime} />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", gap: SP.sm }}>
                  <div style={{ color: C.text, fontWeight: 700, fontSize: 15 }}>{l.name}</div>
                  {l.is_archived && (
                    <span style={{ background: C.surface3, color: C.textMuted, fontSize: 9, fontWeight: 700, letterSpacing: 1, padding: "2px 6px", borderRadius: R.sm, textTransform: "uppercase", display: "inline-flex", alignItems: "center", gap: 4 }}>
                      <IoArchive size={10} /> Archived
                    </span>
                  )}
                </div>
                <div style={{ color: C.textMuted, fontSize: 13 }}>{l.member_count ?? 0} players · Code {l.code}</div>
              </div>
              <IoChevronForward size={20} color={C.textDim} />
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
